
export default {
  name: "ReviewsHeader",
  props: {
    count: {
      type: Number,
      required: true,
    },
  },
};
